import React from "react";
import "./css/LoadingSpinner.css";

export default function SmallLoadingSpinner() {
    return (
        <div className="xs-spinner-container">
            <div className="xs-loading-spinner"></div>
        </div>
    );
}